import React, { Component } from 'react';
import NumberFormat from 'react-number-format';

class TaxLine extends Component {
    render() {
        return (
            <div className="tax-line">
                <div className="amount">
                    <NumberFormat value={this.props.income} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale="2"  fixedDecimalScale="true"/>
                </div>
                <div className="tax">
                    <NumberFormat value={this.props.tax} displayType={'text'} thousandSeparator={true} prefix={'$'} 
                    decimalScale="2"  fixedDecimalScale="true"/>
                </div>
                <div className="after-tax">
                    <NumberFormat value={this.props.incomeAfterTax} displayType={'text'} thousandSeparator={true} prefix={'$'} 
                    decimalScale="2" fixedDecimalScale="true"/>
                </div>
                <div className="marginal-tax-rate">
                    <NumberFormat value={this.props.marginalTaxRate} displayType={'text'} thousandSeparator={true} 
                    decimalScale="2" fixedDecimalScale="true"/>%
                </div>
            </div>
        );
    }
}

export default TaxLine;
